import { tw } from "@sveabank/cc-common";

type Props = {
	isActive?: boolean;
	activeText: string;
	inactiveText: string;
};

const NavLabel = ({ isActive, activeText, inactiveText }: Props) => (
	<div className={tw("text-interactive-primary text-center text-sm font-medium")}>
		{isActive ? (
			<span>{activeText}</span>
		) : (
			<span className="laptop:block hidden">{inactiveText}</span>
		)}
	</div>
);

export default NavLabel;
